import React from 'react';
import { Heart, Users, Gift, Sparkles } from 'lucide-react';
import { aboutInfo } from '../data/mock';

const About = () => {
  const features = [
    {
      icon: Heart,
      title: "Kærlighed",
      description: "Vi giver børn en magisk juleaften fyldt med varme og omsorg."
    },
    {
      icon: Users,
      title: "Fællesskab",
      description: "Hele Vejle bakker op - fra frivillige til lokale virksomheder."
    },
    {
      icon: Gift,
      title: "Personlige Gaver",
      description: "Hvert barn modtager gaver baseret på deres egne ønsker."
    },
    {
      icon: Sparkles,
      title: "Magi",
      description: "En aften hvor drømme går i opfyldelse og minder skabes."
    }
  ];

  return (
    <section id="om-os" className="py-24 bg-gradient-to-b from-[#faf7f2] to-white" aria-labelledby="about-heading">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <header className="text-center mb-16">
          <span className="inline-block text-[#1a472a] font-semibold text-sm uppercase tracking-wider mb-4">
            Om Os
          </span>
          <h2 id="about-heading" className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            En fest der gør en forskel
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            {aboutInfo.mission}
          </p>
        </header>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl p-8 shadow-lg shadow-gray-100 border border-gray-100 hover:border-[#1a472a]/20 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-14 h-14 bg-[#1a472a]/10 rounded-xl flex items-center justify-center mb-6 group-hover:bg-[#1a472a] transition-colors duration-300">
                <feature.icon className="w-7 h-7 text-[#1a472a] group-hover:text-white transition-colors duration-300" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* Story Section */}
        <div className="bg-[#1a472a] rounded-3xl p-8 sm:p-12 lg:p-16 text-white">
          <div className="max-w-3xl mx-auto">
            <h3 className="text-2xl sm:text-3xl font-bold mb-6">
              Vores Historie
            </h3>
            <div className="text-white/80 text-lg leading-relaxed space-y-4">
              {aboutInfo.history.split('\n\n').map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>
            <div className="mt-8 pt-8 border-t border-white/20">
              <p className="text-[#f5d742] font-semibold text-lg">
                {aboutInfo.partnership}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
